import { render, staticRenderFns } from "./MflsValues_rev.vue?vue&type=template&id=27185d4e"
import script from "./MflsValues_rev.vue?vue&type=script&lang=js"
export * from "./MflsValues_rev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports